<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AccountNotifications',
    computed: {
        ...mapGetters(['userResource'])
    },
    data() {
        return {
            optInAccount: null,
            optInMarketing: null,
            optInChangesMade: false,
        }
    },
    methods: {
        async onSaveNotifPrefs() {
            this.userResource.attributes.opt_in_account_updates = this.optInAccount
            this.userResource.attributes.opt_in_marketing_updates = this.optInMarketing
            await this.userResource.save()
            this.optInChangesMade = false
        }
    },
    mounted() {
        this.optInAccount = this.userResource.attributes.opt_in_account_updates
        this.optInMarketing = this.userResource.attributes.opt_in_marketing_updates
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Notifications</h4>
            <p class="text-muted mb-0">Contrôlez comment et quand nous vous contactons.</p>
        </div>
        <b-card>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInAccount" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Mises à jour du compte</span>
                    <small class="text-muted">
                        Messages transactionnels liés à votre compte, vos commandes ou les services que vous avez demandés — y compris les rappels de rendez-vous, les confirmations de commande et les notifications de compte. Des frais de message et de données peuvent s'appliquer. Répondez AIDE pour obtenir de l'aide ou STOP pour vous désinscrire.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-form-group class="mb-4">
                <b-form-checkbox v-model="optInMarketing" @input="optInChangesMade = true" switch>
                    <span class="font-weight-bold d-block">Marketing &amp; Promotions</span>
                    <small class="text-muted">
                        Offres spéciales, réductions et mises à jour de nouveaux produits. Des frais de message et de données peuvent s'appliquer. Répondez AIDE pour obtenir de l'aide ou STOP pour vous désinscrire.
                    </small>
                </b-form-checkbox>
            </b-form-group>
            <b-button variant="primary" :disabled="!optInChangesMade" @click="onSaveNotifPrefs()">Enregistrer les préférences</b-button>
        </b-card>
    </div>
</template>
